'use es6';

import keyMirror from 'react-utils/keyMirror';
export default keyMirror({
  DEFAULT: null,
  BACKUP: null
});